// extracted by mini-css-extract-plugin
export default {"page":"Placeholder_page__sSfFe","homeBtn":"Placeholder_homeBtn__uR-S-"};